import { render, staticRenderFns } from "./view.vue?vue&type=template&id=882e6a68&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=882e6a68&prod&scoped=true&lang=css&"
import style1 from "./view.vue?vue&type=style&index=1&id=882e6a68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882e6a68",
  null
  
)

export default component.exports